import {applySnapshot, getSnapshot, Instance, types} from "mobx-state-tree";
import {validateEmail, validatePhone} from "../utils/Validations";
import {formatI18nKeys} from "../utils/I18n";
import {LINK_TYPE_COMMUNITY_PAGE} from "../screens/LinkDetailsScreen";

const DeeplinkStore = types.model({
    expiration: types.string,
    ogDescription: types.string,
    ogDescriptionIsEdited: types.boolean,
    isLoading: types.boolean,
    isExpired: types.boolean,
    url: types.string,
    linkType: types.string,
    urlQrCode: types.string,
    textToShare: types.string,
    email: types.string,
    isNewGroup: types.boolean,
    hasInviter: types.boolean,
    isPrivate: types.boolean,
    isDefault: types.boolean,
    failedGeneratingLink: types.boolean,
    linkId: types.string,
})
    .views(self => ({
        get canProceed(): boolean {
            return true;
        },
        get emailCanProceed(): boolean {
            const emails = self.email.split(',')
            for (let i = 0; i < emails.length; i++) {
                const valid = validateEmail(emails[i])
                if (!valid) return false
            }
            return true
        },
    }))
    .actions(self => {
        let initialState = {};
        return {
            afterCreate() {
                initialState = getSnapshot(self);
            },
            reset: () => {
                applySnapshot(self, initialState);
            },
            setIsPrivate: function (value: boolean) {
                self.isPrivate = value
            },
            setDefaultOgDescription: function (groupName: string) {
                if (self.ogDescriptionIsEdited) return
                self.ogDescription = formatI18nKeys('link_detail_default_og_description', groupName);
            },
            setOgDescription: function (value: string) {
                if (!self.ogDescriptionIsEdited) {
                    self.ogDescriptionIsEdited = true;
                }
                self.ogDescription = value;
            },
            setExpiration: function (value: string) {
                self.expiration = value
            },
            setLinkType(value: string) {
                self.linkType = value;
            },
            setEmail(value: string) {
                self.email = value;
            },
            setLoading(value: boolean) {
                self.isLoading = value;
            },
            setIsNewGroup(value: boolean) {
                self.isNewGroup = value;
            },
            setHasInviter(value: boolean) {
                self.hasInviter = value;
            },
            setIsDefault(value: boolean) {
                self.isDefault = value;
            }
        }
    });

export interface IDeeplinkStore extends Instance<typeof DeeplinkStore> {
}

export const DeeplinkDefaultStore = {
    ogDescription: '',
    ogDescriptionIsEdited: false,
    expiration: '',
    isLoading: true,
    url: '',
    isExpired: false,
    urlQrCode: '',
    textToShare: '',
    phoneNumber: '',
    isPrivate: false,
    isDefault: true,
    countryCode: '',
    email: '',
    isNewGroup: true,
    hasInviter: true,
    failedGeneratingLink: false,
    linkType: LINK_TYPE_COMMUNITY_PAGE,
    linkId: '' // For editing
};

export default DeeplinkStore;
